import { Card, Flex, Typography } from 'antd';
import { ResetForm } from '../components/auth/ResetForm.tsx';

export const ResetPasswordPage = () => {
  return (
    <Flex vertical align="center" gap="md">
      <Typography.Title>Crown Sitter</Typography.Title>
      <Typography.Text>シッター用アプリ</Typography.Text>
      <Card style={{ marginTop: 10 }}>
        <ResetForm />
      </Card>
    </Flex>
  );
};
